import { createContext, useState } from "react";

export const SettingsProcountorContext = createContext(undefined);

export const SettingsProcountorContextProvider = ({ children }) => {
  const [editedCells, setEditedCells] = useState([]);
  const [benefitEditedCells, setBenefitEditedCells] = useState([]);

  return (
    <SettingsProcountorContext.Provider
      value={{
        editedCells,
        setEditedCells,
        benefitEditedCells,
        setBenefitEditedCells,
      }}
    >
      {children}
    </SettingsProcountorContext.Provider>
  );
};
